export default {
      id: "icon-location-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-location",
      toString: function () {
        return this.url;
      }
    }